import { Box, Paragraph } from '@zillow/constellation-10';
import WrongAccountAlert from '../../../WrongAccountAlert';

type ErrorContainerProps = {
  hasAuthError: boolean;
};

const GENERIC_ERROR_MESSAGE = 'There was an error, please try again.';

export default function ErrorContainer({ hasAuthError }: ErrorContainerProps) {
  if (hasAuthError) {
    return (
      <Box
        css={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          padding: 'default',
        }}
      >
        <WrongAccountAlert textLabel="conversation" />
      </Box>
    );
  }

  return (
    <Box
      css={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
      }}
    >
      {/* oxlint-disable-next-line constellation/prefer-semantic-tokens -- pre-existing base token; ESLint treated this as warn-level, not blocking */}
      <Paragraph css={{ color: 'red.400' }}>{GENERIC_ERROR_MESSAGE}</Paragraph>
    </Box>
  );
}
